import UserList from "./UserList";

export default function UsersPage() {
  return <UserList />;
}
